import type { ReactNode } from 'react';
import { S, t } from '../i18n/strings';
import { AUTHORS } from '../lib/authors';
import { useSteve } from '../state/context';

/**
 * Les auteurs de Steve. Avec ceux cités dans les textes de présentation, ce
 * sont les seuls liens sortants du site.
 *
 * `rel="noopener"` coupe l'accès à `window.opener` depuis l'onglet ouvert ;
 * `noreferrer` fait doublon avec l'en-tête `Referrer-Policy: no-referrer` du
 * site, mais tient aussi si la page est un jour servie ailleurs.
 */

interface Props {
  /** Conteneur, habillé par le skin. */
  readonly className?: string | undefined;
  /** Liens vers les auteurs. */
  readonly linkClassName?: string | undefined;
  /** Ajoute « site hommage, non officiel » à la suite. */
  readonly unofficial?: boolean;
}

/**
 * « un personnage créé par Vigz · musique Tomo », avec les liens vers leurs
 * comptes. Présent dans le pied des six skins : la paternité de Steve ne dépend
 * pas de l'interface sur laquelle on atterrit.
 */
export function Credits({ className, linkClassName, unofficial = false }: Props): ReactNode {
  const { lang } = useSteve();

  return (
    <span className={className}>
      {t(S.common.credit_idea, lang)}{' '}
      <a className={linkClassName} href={AUTHORS.Vigz} target="_blank" rel="noopener noreferrer">
        Vigz
      </a>
      {/*
        Une espace, pas un point médian : la formulation est une phrase suivie
        — « Un personnage original de Vigz mis en musique par Tomo » — et non
        deux mentions juxtaposées.
      */}
      {' '}
      {t(S.common.credit_music, lang)}{' '}
      <a className={linkClassName} href={AUTHORS.Tomo} target="_blank" rel="noopener noreferrer">
        Tomo
      </a>
      {unofficial && <> · {t(S.common.credit_unofficial, lang)}</>}
    </span>
  );
}
